import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GlobalFooterComponent } from './global-footer.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [GlobalFooterComponent],
  exports: [GlobalFooterComponent]
})
export class GlobalFooterModule { }
